import React, { useEffect } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
  TextAreaBase,
  PickerSelectSimple,
} from "@reusejs/react";
import { getTopics, contactUs } from "services";

const noDigits: RegExp = /^([^0-9]*)$/;
const mobileNumberRegEx: RegExp = /^[0-9]{0,10}$/;

export default function ContactUsForm(props: any) {
  const form = useBetaForm({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    topic: "",
    message: "",
  });

  const form_constraints = {
    first_name: {
      presence: {
        allowEmpty: false,
      },
    },
    last_name: {
      presence: {
        allowEmpty: false,
      },
    },
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    mobile_number: {
      presence: {
        allowEmpty: false,
      },
      numericality: {
        onlyInteger: true,
      },
    },
    topic: {
      presence: {
        allowEmpty: true,
      },
    },
    message: {
      presence: {
        allowEmpty: true,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const hanldeSubmit = async () => {
    try {
      if (form.validate()) {
        await contactUs(form.value).then((res) => {
          form.setField("first_name", "");
          form.setField("last_name", "");
          form.setField("email", "");
          form.setField("mobile_number", "");
          form.setField("topic", "");
          form.setField("message", "");
        });
        props.setFlag(true);
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };

  return (
    <div className="space-y-3 sm:space-y-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:space-x-8 space-y-3 sm:space-y-0">
        <div className="w-full">
          <TextInputBase
            labelBaseProps={{
              label: "First name",
              labelBaseClasses: { font: "text-base font-medium" },
            }}
            name={"first_name"}
            onChange={(val) => {
              if (typeof val === "string") {
                noDigits.test(val) && form.setField("first_name", val);
              }
            }}
            placeholder={"Enter your first name"}
            type={"text"}
            error={
              form.errors.get("first_name") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("first_name")[0]}
                </p>
              ) : null
            }
            value={form.getField("first_name")}
            htmlFor={"first_name"}
            textInputBaseClasses={{
              font: "text-base font-medium",
              formInput: "text-base font-medium text-red",
            }}
          />
        </div>
        <div className="w-full">
          <TextInputBase
            labelBaseProps={{
              label: "Last name",
              labelBaseClasses: { font: "text-base font-medium" },
            }}
            name={"last_name"}
            onChange={(val) => {
              if (typeof val === "string") {
                noDigits.test(val) && form.setField("last_name", val);
              }
            }}
            placeholder={"Enter your last name"}
            type={"text"}
            error={
              form.errors.get("last_name") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("last_name")[0]}
                </p>
              ) : null
            }
            value={form.getField("last_name")}
            htmlFor={"last_name"}
            textInputBaseClasses={{
              font: "text-base font-medium",
              formInput: "text-base font-medium",
            }}
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:space-x-8 space-y-3 sm:space-y-0">
        <div className="w-full">
          <TextInputBase
            labelBaseProps={{
              label: "Email",
              labelBaseClasses: { font: "text-base font-medium" },
            }}
            name={"email"}
            onChange={(val) => form.setField("email", val)}
            placeholder={"Enter your email"}
            type={"text"}
            error={
              form.errors.get("email") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("email")[0]}
                </p>
              ) : null
            }
            value={form.getField("email")}
            htmlFor={"email"}
            textInputBaseClasses={{
              font: "text-base font-medium",
              formInput: "text-base font-medium",
            }}
          />
        </div>
        <div className="w-full">
          <TextInputBase
            labelBaseProps={{
              label: "Phone number",
              labelBaseClasses: { font: "text-base font-medium" },
            }}
            name={"mobile_number"}
            onChange={(val) => {
              if (typeof val === "string") {
                (mobileNumberRegEx.test(val) || val === "") &&
                  form.setField("mobile_number", val);
              }
            }}
            placeholder={"Enter your phone numder"}
            type={"text"}
            error={
              form.errors.get("mobile_number") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("mobile_number")[0]}
                </p>
              ) : null
            }
            value={form.getField("mobile_number")}
            htmlFor={"mobile_number"}
            textInputBaseClasses={{
              font: "text-base font-medium",
              formInput: "text-base font-medium",
            }}
          />
        </div>
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async () => {
            const data: any = getTopics();
            const filteredData = data.map((item: any) => {
              return { value: item.slug, label: item.name };
            });
            return filteredData;
          }}
          pickerSelectSimpleClasses={{
            selectedDataClasses: {
              placeholderClasses: {
                font: "text-2xl font-normal",
              },
            },
          }}
          // selectedDataClasses
          defaultSelected={
            form.getField("topic") !== "" ? [form.getField("topic")] : []
          }
          labelBaseProps={{
            label: "Topic",
            labelBaseClasses: { font: "text-base font-medium" },
          }}
          onChange={(value: any) => {
            form.setField("topic", value);
          }}
          error={
            form.errors.get("topic") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("topic")[0]}
              </p>
            ) : null
          }
          defaultString="Select a Topic"
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
        />
      </div>
      <div>
        <TextAreaBase
          placeholder="Enter message here"
          name="message"
          labelBaseProps={{
            label: "Your message",
            labelBaseClasses: { font: "text-base font-medium" },
          }}
          onChange={(val) => {
            form.setField("message", val);
          }}
          error={
            form.errors.get("message") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("message")[0]}
              </p>
            ) : null
          }
          textAreaBaseClasses={{
            margin: "mt-1",
            background: "bg-white dark:bg-gray-900",
            border: "border-gray-300 dark:border-gray-600",
            display: "block ",
            width: "w-full",
            color: "text-gray-900 dark:text-white",
            font: "text-base font-normal",
            padding: "",
            shadow: "shadow-sm",
          }}
          value={form.getField("message")}
        />
      </div>

      <div className="text-xxs font-normal md:text-sm text-gray-500">
        By submitting this form you agree to our terms and conditions and our
        Privacy Policy which explains how we may collect, use and disclose your
        personal information including to third parties.
      </div>

      <ButtonBase
        variant="primary"
        label="Send Message"
        onClick={hanldeSubmit}
        buttonBaseClasses={{
          font: "text-base md:text-sm font-medium",
          backgroundColor: "bg-blue-600 hover:bg-blue-700",
          textColor: "text-white",
          border: "any",
          width: "",
          padding: "px-4 py-3",
        }}
      />
    </div>
  );
}
